// Central content + imagery for Shelterease Housing Association
import {
  Home, HandCoins, Wallet, GraduationCap, Briefcase, BookOpen, Languages,
  Compass, Users, HeartPulse, KeyRound, MoveRight, Shield, FileText, Wrench
} from "lucide-react";

export const COMPANY = {
  name: "Shelterease Housing Association",
  slogan: "Safe Housing. Strong Futures.",
  phone: "024 7699 5724",
  emergency: "0800 123 4567",
  email: "info@shelterease.org.uk",
  address: "First Floor, 101 Lockhurst Lane, Coventry, CV6 5SF",
  hours: "Mon–Fri, 9:00am – 5:00pm",
  reg: "Company No. 15573918 · Registered in England & Wales",
  socials: ["LinkedIn", "Facebook", "Instagram", "X"],
};

export const IMG = {
  heroHouse: "https://images.unsplash.com/photo-1710883727427-59d1ccc368fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  familyHug: "https://images.unsplash.com/photo-1650523616477-c0b945a43c1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  womanChild: "https://images.unsplash.com/photo-1781263409522-06f1d4a6f3af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  portraitWoman: "https://images.unsplash.com/photo-1591079068288-ba20b850c81a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  community: "https://images.unsplash.com/photo-1783626860180-c5138d52db0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  volunteers: "https://images.unsplash.com/photo-1542323228-002ac256e7b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  foodBank: "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  esol: "https://images.unsplash.com/photo-1758270704925-fa59d93119c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office: "https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  officeHigh5: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  livingRoom: "https://images.unsplash.com/photo-1710883727450-d3a0ab1bbbe3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  livingRoom2: "https://images.unsplash.com/photo-1596716587659-a922cc68513f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  business: "https://images.unsplash.com/photo-1495653797063-114787b77b23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  handshake: "https://images.unsplash.com/photo-1511376979163-f804dff7ad7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroMan: "https://images.unsplash.com/photo-1758874574397-e56dfcfc116d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  advice: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  refugeeGroup: "https://images.unsplash.com/photo-1708513426827-2c00fbb6300c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ishaq: "https://images.unsplash.com/photo-1659093728055-45f8275166d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  houseInterior: `${process.env.PUBLIC_URL}/img/house.webp`,
  cvClinic: `${process.env.PUBLIC_URL}/img/cv-clinic.jpg`,
  welcomeRefugees: `${process.env.PUBLIC_URL}/img/welcome-refugees.jpg`,
  welcomeUmbrella: `${process.env.PUBLIC_URL}/img/welcome-umbrella.jpg`,
  employmentSupport: `${process.env.PUBLIC_URL}/img/employment-support.webp`,
  p1: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  p2: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  p3: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  p4: "https://images.unsplash.com/photo-1621624666561-84d0107001dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  p5: "https://images.unsplash.com/photo-1567122087721-47b09b61e1d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  p6: "https://images.unsplash.com/photo-1596510914965-9ae08acae566?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
};

export const NAV = [
  { label: "About", to: "/about" },
  { label: "Accommodation", to: "/accommodation" },
  { label: "Support Services", to: "/support-services" },
  { label: "Referrals", to: "/referrals" },
  { label: "Landlords", to: "/landlords" },
  { label: "Volunteer", to: "/volunteer" },
  { label: "Business", to: "/business" },
  { label: "Tenant Hub", to: "/tenant-hub" },
  { label: "News", to: "/news" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  { icon: Home, title: "Housing & Tenancy Support", desc: "Practical help understanding tenancies, rights and responsibilities, and settling safely into a new home." },
  { icon: HandCoins, title: "Welfare Benefits Support", desc: "Guidance on entitlements and applications so residents receive the support they are due." },
  { icon: Wallet, title: "Universal Credit & Housing Benefit", desc: "Hands-on assistance with claims, journals, and housing costs to keep tenancies secure." },
  { icon: HeartPulse, title: "Budgeting & Financial Wellbeing", desc: "Building confidence with money, saving, and managing everyday household costs." },
  { icon: Briefcase, title: "Employment Support", desc: "CVs, applications, interview practice and links to employers offering real opportunities." },
  { icon: GraduationCap, title: "Education Support", desc: "Access to courses, qualifications and learning pathways for every stage of life." },
  { icon: Languages, title: "ESOL Referrals", desc: "Connecting residents to English classes and conversation groups to build confidence." },
  { icon: Compass, title: "Immigration Signposting", desc: "Trusted signposting to qualified legal advice and immigration support services." },
  { icon: Users, title: "Community Integration", desc: "Events, activities and introductions that turn a new city into a real community." },
  { icon: HeartPulse, title: "Wellbeing Support", desc: "Emotional and mental health support to help people feel settled, safe and hopeful." },
  { icon: KeyRound, title: "Independent Living Skills", desc: "Everyday skills — cooking, admin, transport and more — for confident independent living." },
  { icon: MoveRight, title: "Move-on Support", desc: "Careful planning and practical help to move on to settled, long-term accommodation." },
];

export const STATS = [
  { value: 160, suffix: "+", label: "People supported into safe homes" },
  { value: 96, suffix: "%", label: "Residents reporting greater confidence" },
  { value: 6, suffix: "", label: "Years of frontline experience" },
  { value: 12, suffix: "+", label: "Partner organisations & landlords" },
];

export const TESTIMONIALS = [
  { quote: "Shelterease gave me more than a room. They helped me open a bank account, find college, and believe I belonged here.", name: "Ishaq", role: "Resident, from Sudan", img: IMG.ishaq },
  { quote: "The team understood my situation from day one. Within months I had a job and, for the first time, a real sense of home.", name: "Yusuf", role: "Former resident", img: IMG.p2 },
];

export const VALUES = [
  { n: "01", title: "Compassion", desc: "Founded by people with lived experience, we meet every person with warmth and dignity." },
  { n: "02", title: "Professionalism", desc: "Rigorous standards, clear communication and reliable partnership with every stakeholder." },
  { n: "03", title: "Safety", desc: "Safe, well-maintained accommodation and robust safeguarding at the heart of all we do." },
  { n: "04", title: "Independence", desc: "Every plan is built to help residents become confident, capable and self-reliant." },
];

export const TEAM = [
  { name: "Dr. Layla Hassan", role: "Chief Executive", img: IMG.p3 },
  { name: "Marcus Bennett", role: "Head of Housing", img: IMG.p1 },
  { name: "Sofia Almeida", role: "Support Services Lead", img: IMG.p4 },
  { name: "David Okoro", role: "Partnerships & Referrals", img: IMG.p2 },
];

export const PARTNERS = [
  { name: "Coventry City Council", logo: `${process.env.PUBLIC_URL}/img/partners/coventry-city-council.png` },
  { name: "Coventry Refugee & Migrant Centre", logo: `${process.env.PUBLIC_URL}/img/partners/crmc.webp` },
  { name: "Home Office", logo: `${process.env.PUBLIC_URL}/img/partners/home-office.webp` },
  { name: "Citizens Advice", logo: `${process.env.PUBLIC_URL}/img/partners/citizens-advice.webp` },
  { name: "St Francis Employability", logo: `${process.env.PUBLIC_URL}/img/partners/st-francis.webp` },
  { name: "WATCH Community Centre", logo: `${process.env.PUBLIC_URL}/img/partners/watch-community.png` },
];

export const FAQS = [
  { q: "What is Supported Exempt Accommodation?", a: "It is accommodation that comes with more than minimal care, support or supervision. Residents receive personalised support alongside a safe place to live, helping them build independence." },
  { q: "Who is eligible for support?", a: "We support refugees, newly recognised refugees, migrants and vulnerable adults who need supported accommodation and are ready to work towards independent living." },
  { q: "How do referrals work?", a: "Local authorities, Home Office providers, charities and support organisations can refer through our online referral form. Our team responds within two working days." },
  { q: "What support is included?", a: "Housing and tenancy support, benefits guidance, budgeting, employment and education help, ESOL referrals, wellbeing support and move-on planning." },
  { q: "How long can someone stay?", a: "Stays are based on individual need and support plans. We focus on a positive, planned move-on to settled accommodation when the resident is ready." },
];
